<template>
  <div>
    <v-card color="grey lighten-4" flat tile>
      <v-toolbar dense>
        <v-toolbar-title>
          <a @click="goTo('/')" class="font-weight-light">malldesa.com</a>
        </v-toolbar-title>

        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>
    <v-container>
      <v-row>
        <v-col cols="1"></v-col>
        <v-col cols="7">
          <h1>Checkout</h1>
          <div class="my-5">
            <h3>Alamat Pengiriman</h3>
          </div>
          <v-divider></v-divider>
          <div v-for="data in dataAlamat" :key="data.alamat_id">
            <div class="mt-5 mb-2">
              <b>{{ data.penerima }}</b>
              ({{ data.nama_alamat }})
              <v-chip color="#263238" small class="ma-2" label>
                <b style="color: #FFEB3B;">{{ data.status }}</b>
              </v-chip>
            </div>
            <div>{{ data.penerimahp }}</div>
            <div class="just-info">{{ data.jalan }}</div>
            <div class="just-info">{{ data.kecamatan }}, {{ data.kota }}, {{ data.kodepos }}</div>
          </div>
          <v-divider class="my-5"></v-divider>
          <v-btn class="mx-5" @click="dialogAlamat()" outlined medium>Pilih alamat lain</v-btn>
          <v-dialog v-model="alamatLain" width="700">
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title>
                Pilih Alamat Lain
                <v-spacer></v-spacer>
                <v-icon @click="alamatLain = false">fas fa-times-circle</v-icon>
              </v-card-title>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Data Penerima</th>
                      <th class="text-left">Alamat</th>
                      <th class="text-left">Daerah Pengiriman</th>
                      <th class="text-left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in selAlamat" :key="item.alamat_id">
                      <td class="my-5">
                        <div>
                          <b>{{ item.penerima }}</b>
                        </div>
                        {{ item.penerimahp }}
                      </td>
                      <td class="my-5">
                        <div>
                          <b>{{ item.nama_alamat }}</b>
                        </div>
                        <div>{{ item.jalan }}</div>
                      </td>
                      <td class="my-5">
                        <div>
                          <b>{{ item.provinsi }}</b>
                        </div>
                        <div>{{ item.kota }}</div>
                        <div>{{ item.kecamatan }}</div>
                        <div>{{ item.kodepos }}</div>
                      </td>
                      <td>
                        <v-btn
                          @click="pilihAlamat(item.alamat_id)"
                          outlined
                          small
                          color="primary"
                        >Pilih Alamat</v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-card class="my-5" height="2" color="#B2DFDB"></v-card>
          <div v-for="cart in carts" :key="cart.id">
            <v-icon>fas fa-store</v-icon>
            <b class="mx-3">{{ cart.nama_toko }}</b>
            <v-btn
              @click="dialogKurir(cart.nama_toko)"
              small
              class="ma-2"
              tile
              outlined
              color="success"
            >
              <v-icon left>fas fa-truck</v-icon>Pilih Jasa Pengiriman
            </v-btn>
            <div v-for="barang in cart.barang" :key="barang.id">
              <v-row>
                <v-col cols="2">
                  <v-img :src="getImageUrl(barang.gambar)" width="auto" height="auto"></v-img>
                </v-col>
                <v-col cols="10">
                  <v-row>
                    <v-col cols="6">
                      <div class="nama-barang">{{ barang.nama }}</div>
                      <div class="harga-barang">{{ barang.harga | currency }}</div>
                      <div class="qty-barang">{{ barang.qty }} barang({{ barang.berat }} kg)</div>
                      <div class="qty-barang">
                        <b>Catatan :</b>
                        {{ barang.catatan }}
                      </div>
                    </v-col>

                    <v-col v-if="barang.kurir !=null && barang.kurir !=404" cols="6">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">Kurir</th>
                              <th class="text-left">Service</th>
                              <th class="text-left">Ongkos/kg</th>
                              <th class="text-left">Ongkos</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <b>{{ cart.kurir }}</b>
                              </td>
                              <td>{{ cart.service }}</td>
                              <td>{{ cart.ongkir | currency }}</td>
                              <td>{{ cart.ongkir * barang.berat | currency }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-divider class="my-5"></v-divider>
            </div>
          </div>
          <span class="total-harga">Subtotal</span>
          <span class="total" style="float: right;">
            {{
            cartHeader.total | currency
            }}
          </span>
          <v-card class="my-5" height="2" color="#B2DFDB"></v-card>
        </v-col>
        <v-col cols="3">
          <v-card class="sticky">
            <div class="pa-3">
              <h3>Ringkasan Belanja</h3>
              <v-divider class="my-3"></v-divider>
              <span class="total-harga mr-10">Total Harga({{ cartLength }} Produk)</span>
              <span class="total">{{ cartHeader.total | currency }}</span>
              <div>
                <span class="total-harga">Total Ongkos Kirim</span>
                <span
                  class="ongkir"
                  v-if="cartHeader.total_ongkir !=null"
                >{{ cartHeader.total_ongkir | currency }}</span>
              </div>
              <v-divider class="my-3"></v-divider>
              <span class="total-harga">Total Tagihan</span>
              <span class="total">
                {{
                cartHeader.total + cartHeader.total_ongkir
                | currency
                }}
              </span>
            </div>
            <div class="pa-3">
              <v-btn @click="Pay(dataUser)" block outlined medium>Bayar</v-btn>
            </div>
          </v-card>
        </v-col>
        <v-col cols="1"></v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="selKurir" max-width="700">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Jasa Pengiriman
          <v-spacer></v-spacer>
          <v-icon @click="selKurir = false">fas fa-times-circle</v-icon>
        </v-card-title>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Kurir</th>
                <th class="text-left">Service</th>
                <th class="text-left">Harga/Kg</th>
                <th class="text-left">Estimasi</th>
                <th class="text-left"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="jasa in kurir" :key="jasa.aduh">
                <td>
                  <b>{{ jasa.kurir }}</b>
                </td>
                <td>{{ jasa.note }}</td>
                <td>{{ jasa.value | currency }}/Kg</td>
                <td>{{ jasa.etd }} Hari</td>
                <td>
                  <v-btn @click="pilihKurir(jasa)" color="#0091EA" dark small>Pilih</v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="payment" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Cara Pembayaran
          <v-spacer></v-spacer>
          <!-- <v-icon @click="payment = false">fas fa-times-circle</v-icon> -->
        </v-card-title>

        <div class="pa-3">
          <div>
            <div class="text-center invoice">{{dataBayar.KODE}}</div>
            <div class="text-center total-bayar">{{dataBayar.TOTALBAYAR | currency}}</div>
            <div class="text-center">
              Virtual Account BNI :
              <b>{{dataBayar.VIRTUALACCOUNT}}</b>
            </div>
            <v-divider class="my-3"></v-divider>
            <div class="warning">
              <p>Harap bayar sesuai dengan nominal yang tertera untuk memudahkan proses verifikasi pesanan anda</p>
              <p>
                Pihak Smart247
                <br />
                <b>TIDAK BERTANGGUNG JAWAB</b> apabila ada kekeliruan data dalam proses verifikasi jika nominal yang kami terima tidak sesuai dengan yang tertera
              </p>
            </div>
          </div>
        </div>
        <v-divider class="my-4"></v-divider>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>Petunjuk Transfer ATM</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="pa-3">
                <v-flex xs12 md12 lg12>
                  <v-row>
                    <v-col cols="2" class="pa-0">
                      <v-chip class="mb-2" small label>1.</v-chip>
                      <br />
                      <v-chip class="mb-2" small label>2.</v-chip>
                      <br />
                      <v-chip class="mb-2" small label>3.</v-chip>
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="9" class="pa-0">
                      <div class="mb-2">
                        Pilih
                        <b>Menu Lain > Transfer</b>
                      </div>
                      <div class="mb-2">
                        Pilih Jenis rekening asal dan pilih
                        <b>Virtual Account Billing</b>
                      </div>
                      <div class="mb-2">
                        Masukkan Nomor virtual account
                        <b>{{dataBayar.VIRTUALACCOUNT}}</b> dan pilih Benar
                      </div>
                    </v-col>
                  </v-row>
                </v-flex>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="goTo('/')">Mengerti</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      alamatLain: false,
      selectedKurir: null,
      overlay: false,
      payment: false,
      dataBayar: [],
      selAlamat: [],
      defaultAlamat: localStorage.getItem("alamat_id"),
      // defaultAlamat: null,
      isLoading: false,
      dataUser: [],
      dataAlamat: [],
      carts: [],
      cartLength: null,
      cartHeader: [],
      userid: localStorage.getItem("user_id"),
      idkeranjang: localStorage.getItem("idkeranjang"),
      token: localStorage.getItem("token"),
      kurir: [],
      selKurir: false,
      ongkir: localStorage.getItem("ongkir"),
      filterService: []
    };
  },
  mounted() {
    if (this.token == null) {
      this.$router.push("/login");
    } else {
      this.overlay = true;
      this.getCart();
      this.getDataUser();
      this.invoice();
      this.overlay = false;
    }
  },
  watch: {
    ongkir(newVal, oldVal) {
      console.log(newVal, oldVal);
    }
  },
  computed: {},
  subTotal() {
    var subTotal = this.carts.map(cart => {
      if (cart) {
        return cart.harga * cart.qty;
      }
    });
    return subTotal;
  },
  totalOngkir() {
    var a = this.carts.map(d => {
      if (d) {
        return d.ongkir;
      }
    });
    return a;
  },

  methods: {
    Pay() {
      if (this.Total != 0 && this.kurir != null) {
        this.overlay = true;
        // alert("1");
        // this.overlay = false;
        var totalan = this.cartHeader.total + this.cartHeader.total_ongkir;
        var inv = localStorage.getItem("invoice");
        console.log(totalan, inv);
        fetch("http://meridinet.saebo.id:2082/Login/api/tagihan", {
          method: "POST",
          body: JSON.stringify({
            bayar: totalan,
            kode: localStorage.getItem("invoice"),
            keterangan: "Midtrans",
            virtualaccount: this.userid,
            no: localStorage.getItem("idkeranjang")
          }),
          headers: {
            "Content-type": "application/json"
          }
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
            if (data == 400) {
              this.overlay = false;
              Swal.fire({
                icon: "error",
                title: "Kurir Kosong",
                text: "Silahkan pilih jenis pengiriman!"
              });
            } else if (data == 404) {
              this.overlay = false;
              Swal.fire({
                icon: "error",
                title: "Gagal",
                text: "Nomor VA Sudah Terdaftar"
              });
            } else {
              this.dataBayar = data.data;
              this.payment = true;
              this.overlay = false;
            }
          });
        // this.loading = true;
        // var inv = localStorage.getItem("invoice");
      } else if (this.Total < 10000) {
        Swal.fire({
          icon: "error",
          title: "Transaction Declined",
          text: "Minimum Transaction above 10.000 IDR",
          footer: "<a href>Go Shop !</a>"
        });
      } else if (this.order_id == null) {
        Swal.fire({
          icon: "error",
          title: "No.Invoice Kosong",
          text: "Klik Tombol Invoice untuk mendapat nomor invoice anda!",
          footer: "Ok"
        });
      } else if (this.kurir == null) {
        Swal.fire({
          icon: "error",
          title: "Kurir Kosong",
          text: "Pilih jenis pengiriman!",
          footer: "Ok"
        });
      }
      // this.$router.push("home");
    },
    invoice() {
      var x = new Date();
      var tahun = x.getFullYear();
      var bulan = x.getMonth() + 1;
      var tanggal = x.getDate();
      var jam = x.getHours();
      var menit = x.getMinutes();
      var detik = x.getMilliseconds();

      var Invoice =
        "FJB" +
        this.idkeranjang +
        "" +
        tahun +
        "" +
        bulan +
        "" +
        tanggal +
        "" +
        jam +
        "" +
        menit +
        "" +
        detik;

      localStorage.setItem("invoice", Invoice);
      return Invoice;
    },
    dialogAlamat() {
      this.alamatLain = true;
    },
    pilihAlamat(data) {
      this.alamatLain = false;
      this.overlay = true;
      var nama_toko = "Sumber Agung";
      var x = parseInt(data);
      console.log(x);
      console.log(this.idkeranjang), console.log(nama_toko);

      fetch("http://meridinet.saebo.id:2082/Login/api/tabel/updkerkur", {
        method: "POST",
        body: JSON.stringify({
          idh: this.idkeranjang,
          nama_toko: null,
          idalamat: x
        }),
        headers: {
          "Content-type": "application/json"
        }
      }).then(response => {
        response.json();
        this.getDataUser();
        this.getCart();
        Swal.fire("Dipilih!", "Alamat berhasil dipilih!", "success");

        this.overlay = false;
      });
    },
    getDataUser() {
      this.overlay = true;
      fetch("http://meridinet.saebo.id:2082/Login/api/ViewUser/" + this.userid)
        .then(response => response.json())
        .then(data => {
          this.dataUser = data;

          this.selAlamat = data.alamat;
          var x = data.alamat;
          this.dataAlamat = x;
          this.overlay = false;
        });
    },

    getCart() {
      this.overlay = true;
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/checkoutpro/" +
          this.idkeranjang +
          "/1000"
      )
        .then(response => response.json())
        .then(data => {
          if (data != "Not Found") {
            this.carts = data.keranjang;
            // console.log(data.alamat_id);
            this.defaultAlamat = data.alamat_id;
            var showAlamat = this.dataAlamat.filter(
              d => d.alamat_id == this.defaultAlamat
            );
            this.dataAlamat = showAlamat;
            var filterAlamat = this.selAlamat.filter(
              d => d.alamat_id != this.defaultAlamat
            );
            this.selAlamat = filterAlamat;
            this.cartHeader = data;
            // var x = this.carts.length;
            // this.cartLength = x;
            this.overlay = false;
          }
        });
    },
    dialogKurir(data) {
      this.overlay = true;
      localStorage.setItem("nama_toko", data);
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/viewongkir/" +
          this.defaultAlamat +
          "/" +
          data
      )
        .then(response => response.json())
        .then(data => {
          console.log(data);
          this.selKurir = true;
          this.kurir = data.kurir;
          this.overlay = false;
        });
    },
    pilihKurir(data) {
      // console.log(data);
      this.overlay = true;
      var nama_toko = localStorage.getItem("nama_toko");

      // console.log(this.idkeranjang);
      // console.log(nama_toko);
      // console.log(data.kurir);
      // console.log(data.note);
      fetch("http://meridinet.saebo.id:2082/Login/api/tabel/updkerkur", {
        method: "POST",
        body: JSON.stringify({
          idh: this.idkeranjang,
          nama_toko: nama_toko,
          idalamat: this.cartHeader.alamat_id,
          kurir: data.kurir,
          service: data.note,
          ongkir: data.value
        }),
        headers: {
          "Content-type": "application/json"
        }
      })
        .then(response => response.json())
        .then(data => {
          console.log(data);

          this.getCart();
          Swal.fire("Dipilih!", "Kurir berhasil dipilih!", "success");
          this.selKurir = false;
          this.overlay = false;
        });
    },

    getImageUrl(e) {
      var x = e.replace(/\.[^/.]+$/, "");
      return `http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/${x}`;
    },
    goTo(e) {
      this.$router.push(e);
    }
  }
};
</script>
<style scoped>
.total-bayar {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 200%;
  letter-spacing: 0px;
  word-spacing: 2px;
  color: #101010;
  font-weight: 700;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.invoice {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 85%;
  letter-spacing: 0px;
  word-spacing: 2px;
  color: #b6b6b6;
  font-weight: normal;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.sticky {
  position: fixed;
  top: 10%;
  width: auto;
}
.nama-barang {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 120%;
  letter-spacing: 0px;
  word-spacing: 2px;
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.harga-barang {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 100%;
  letter-spacing: 0px;
  word-spacing: 2px;
  color: #b71c1c;
  font-weight: 700;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.qty-barang {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 100%;
  letter-spacing: 0px;
  word-spacing: 2px;
  color: #b0bec5;
  font-weight: normal;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.just-info {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 80%;
  letter-spacing: 0px;
  word-spacing: 2px;
  color: #acacac;
  font-weight: 400;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.ongkir {
  float: right;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 100%;
  letter-spacing: 0.5px;
  word-spacing: 2px;
  color: #090909;
  font-weight: 700;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.total {
  float: right;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 100%;
  letter-spacing: 0.5px;
  word-spacing: 2px;
  color: #090909;
  font-weight: 700;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.total-harga {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 100%;
  letter-spacing: 0.5px;
  word-spacing: 2px;
  color: #959595;
  font-weight: 400;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
</style>
